import config from './config'


function _callNative (fnName, params, duration = 15000) {
    return new Promise((resolve, reject) => {
        //console.log('fnName', fnName)
        const _fnName = fnName.split('/')
        const sClass = _fnName[0]
        const hybirdFn = _fnName.length > 1 ? _fnName[1] : _fnName[0]
        try {
            // console.log('WindVane resolve 数据: ', sClass, hybirdFn, params, device().isiOS,device().isAndroid)
            window.WindVane.call(sClass, hybirdFn, params, function (res) {
                try{
                    console.warn('WindVane resolve: ', sClass, hybirdFn, JSON.parse(decodeURIComponent(params)), res)
                } catch (err) {
                    console.warn('WindVane resolve: ', sClass, hybirdFn, params, res/*, err*/)
                }
                resolve(res)
            }, function (e) {
                try{
                    console.warn('WindVane reject: ', sClass, hybirdFn, JSON.parse(decodeURIComponent(params)), e)
                } catch (err) {
                    console.warn('WindVane reject: ', sClass, hybirdFn, params, e/*, err*/)
                }
                reject(e)
            }, duration)
        } catch (e) {
            console.warn('WindVane.call Exception: ', e)
        }
    })
}

function callNative ({
                         fnName = '', params = {}, duration
                     }) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/.+Mac OS X/); //ios终端
    // 由于 iOS 在接收 params 时使用了两次 decode, 所以这里需要针对 iOS encode 两次
    if (isiOS) {
        params = encodeURIComponent(JSON.stringify(params))
    }
    return _callNative(fnName, params, duration)
}


class Message {
    static MSG_TO_SUPER_VIEW = 'MSG_TO_SUPER_VIEW'

    static MSG_TO_SPECIFIED_VIEW = 'MSG_TO_SPECIFIED_VIEW'

    constructor() {
    }

    broadcast(eventName, data) {
        //const unitId = config.unitId
        console.log('发送广播', eventName, data)
        const params= config.nativeBroadcastParamFilter({eventName, data})
        const callFn = config.callNative || callNative
        let ret = callFn({fnName: config.nativeBroadcastAPI, params})
        ret.catch(e=>{
            console.log('catch broadcast error', e)
        })
        return ret
    }

    onBroadcast(eventName, cb) {
        console.error('Message.onBroadcast 抽象方法未实现')
    }

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data = {}) {
        console.error('Message.emitMessageToView 抽象方法未实现')
    }

    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, data = {}) {
        console.error('Message.向父视图发送消息 抽象方法未实现')
    }
}



export default Message
